<template>
  <div class="col-lg-6 col-md-12" id="payment-element">
    <h2>Make Payment</h2>
    <div class="block tabular" style="padding: 20px; position: relative;">
      <div v-if="dashboard.account">
        <p style="text-align: left; font-size: 0.9rem;">
          Enter the amount you wish to pay and optionally the reference number
          of the bill this payment relates to (this is found underneath the
          Account Number on your Bill).
        </p>

        <div v-if="!paymentProcessing">
          <p
            class="payment-requests"
            v-if="dashboard.child_accounts.length === 0"
          >
            <strong>Account Number: </strong> {{ selectedPaymentAccount }}
          </p>

          <div class="payment-requests" v-else>
            <strong>Account Number </strong>
            <div>Choose from your parent account or a child account</div>
            <b-form-select
              class="account-dd"
              v-model="selectedPaymentAccount"
              :options="paymentAccounts"
            ></b-form-select>
          </div>
        </div>

        <PaymentChoice
          ref="paymentChoice"
          gtag-reference="Billing"
          :require-bill-reference="true"
          :is-credit="true"
          @handleRequest="requestPayment"
          @complete="resetPayment"
        ></PaymentChoice>
      </div>

      <div v-else>
        <p style="text-align: left; font-size: 0.9rem;">
          We are unable to take payments from this account
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentChoice from "@/views/Components/Payment/PaymentChoice.vue";

export default {
  name: "MakePayment",
  components: { PaymentChoice },
  props: {
    id: {
      type: String,
      required: true
    },
    dashboard: {
      type: Object,
      required: true
    }
  },
  created() {
    this.setup();
  },
  computed: {
    paymentAccounts() {
      let accounts = [
        {
          value: this.dashboard.account,
          text: this.dashboard.account + " (Parent Account)"
        }
      ];

      this.dashboard.child_accounts.forEach(item => {
        accounts.push({
          value: item.reference,
          text: item.reference + " (Child Account)"
        });
      });

      return accounts;
    }
  },
  data() {
    return {
      selectedPaymentAccount: null,
      paymentLoading: false,
      paymentProcessing: false
    };
  },
  methods: {
    setup() {
      this.selectedPaymentAccount = this.dashboard.account;
    },
    resetPayment() {
      this.paymentProcessing = false;
    },
    requestPayment({ amount, billReference }) {
      this.paymentLoading = true;
      this.paymentProcessing = true;

      const paymentAccount = this.selectedPaymentAccount;

      const id = this.id;

      this.$store
        .dispatch("requestPaymentBilling", {
          amount,
          id,
          billReference,
          paymentAccount
        })
        .then(response => {
          this.$gtag.event("payment", {
            event_category: "paymentRequestedBilling",
            event_label: amount
          });

          this.$refs.paymentChoice.loadPayment(response.data.ref);
        })
        .catch(err => {
          const title = "Payment Error";
          const subtitle = err;
          const samePage = true;
          this.$store.dispatch("pushError", { title, subtitle, samePage });
        })
        .finally(() => {
          this.paymentLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../scss/dashboard.scss";

.payment-input input {
  border-radius: 0;
}

.payment-requests {
  text-align: left;
  font-size: 0.8rem;
}
</style>
